export default __webpack_public_path__ + "static/media/img_step_3.c9125884.svg";